import React from 'react';
import { remCss } from 'src/helpers';

const StopCallIcon = React.memo(({ width = 35, viewBox = '0 0 35 35' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(width)}
    viewBox={viewBox}
  >
    <rect
      id='Rectangle_1315'
      data-name='Rectangle 1315'
      width='35'
      height='35'
      rx='7'
      fill='#fc4b4b'
    />
    <path
      id='telephone-fill'
      d='M1.768.478A1.636,1.636,0,0,1,4.214.631L5.9,2.793a1.635,1.635,0,0,1,.3,1.4L5.68,6.247a.636.636,0,0,0,.167.6l2.3,2.3a.636.636,0,0,0,.6.167l2.052-.513a1.636,1.636,0,0,1,1.4.3l2.162,1.682a1.635,1.635,0,0,1,.153,2.448l-.969.969a2.6,2.6,0,0,1-2.7.658,17.469,17.469,0,0,1-6.572-4.144A17.469,17.469,0,0,1,.139,4.145,2.606,2.606,0,0,1,.8,1.448Z'
      transform='matrix(-0.695, 0.719, -0.719, -0.695, 27.988, 17.419)'
      fill='#fff'
      fillRule='evenodd'
    />
  </svg>
));
StopCallIcon.displayName = 'StopCallIcon';

export default StopCallIcon;
